<template>
<br>
  <footer><a href="https://www.stc.com.sa/">👈 عروضنا رهيبة مثلك وشرواك لا تقول ما علمناك  🤩</a></footer>
</template>
